export enum Palette {
    WHITE          = '#FFFFFF',
    EGGSHELL_WHITE = '#FCFAF2',
    ORANGE         = '#E07A5F',
    LIGHT_ORANGE   = '#FF8C6E',
    DIRTY_ORANGE   = '#F0DAC9',
    TAN            = '#F4F1DE',
    BLUE           = '#3D405B',
    BURGUNDY       = '#8F5D5D',
    YELLOW         = '#F2CC8F',
    MUSTARD        = '#EFCA8C',
    BLACK          = '#1E1E1D',
    TEAL           = '#81B29A',
    DARK_TEAL      = '#5D886F',
    GREY           = '#E4E4E4',
    DARK_GREY      = '#555555',
    DOVE_GREY      = '#707070',
}